import React from "react";
import "jspdf-autotable";
import { AuditTrailFilterOhs, AuditTrailOhs } from "../../../services/FirstAidBoxService";
import { RenderAuditTrailResourceType } from "../../../utils/CommonGroupingItem";
import AuditTrailsTable from "../../common/AuditTrailsTable";

const COLUMNS_TO_SHOW = ["Action Type", "Resource Type", "Resource Name"];

/**
 * Audit Trail tab - every OHS action (boxes, checks, catalog, First Aiders and Managers) through
 * the shared audit trail table, like every other module.
 */
function AuditTrail() {
    return (
        <AuditTrailsTable
            apiFunction={AuditTrailOhs}
            columnsToShow={COLUMNS_TO_SHOW}
            filterArrApi={AuditTrailFilterOhs}
            exportFileName="Occupational Health and Safety Audit Trail"
            isResourceNameShown={true}
            isShowingResourceTypeFilter
            renderResourceTypeFunction={RenderAuditTrailResourceType}
        />
    );
}

export default AuditTrail;
